/** Transaction dates are calendar dates; formatting must not shift them by timezone. */
export function formatDate(value: string | null | undefined): string {
  if (!value) return "Not recorded";
  const day = value.match(/^(\d{4}-\d{2}-\d{2})(?:T|$)/)?.[1];
  if (!day) return "Date unavailable";
  const parsed = new Date(`${day}T12:00:00Z`);
  if (!Number.isFinite(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== day) return "Date unavailable";
  return new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" }).format(parsed);
}
export function formatTimestamp(value: string | null | undefined): string {
  if (!value) return "Not recorded";
  const parsed = new Date(value);
  if (!Number.isFinite(parsed.getTime())) return "Date unavailable";
  const date = new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "short", year: "numeric", timeZone: "Europe/Berlin" }).format(parsed);
  const time = new Intl.DateTimeFormat("en-GB", { hour: "2-digit", minute: "2-digit", timeZoneName: "short", timeZone: "Europe/Berlin" }).format(parsed);
  return `${date} · ${time}`;
}
export function upsellWheelUrl(hubspotCompanyId?: string | null): string {
  return /^\d+$/.test(hubspotCompanyId ?? "")
    ? `https://customerupsellwheel.myneva.eu/customer/${hubspotCompanyId}`
    : "https://customerupsellwheel.myneva.eu/search";
}
